import { GlobalController } from 'src/shared/global/GlobalController'
import PersonConfirmationData from './PersonConfirmationData.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'personConfirmationData',
    component: PersonConfirmationData,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
